export const CANCEL_PROVISION='CANCEL_PROVISION'
export const CANCEL_PROVISION_SUCCESS='CANCEL_PROVISION_SUCCESS'
export const CANCEL_PROVISION_ERROR='CANCEL_PROVISION_ERROR'

export const CancelProvision = (data) => ({
    type: CANCEL_PROVISION,
    payload: data
})